const UpsellView = () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/UpsellView.vue')

export const upsellInstances = [
	{
		id: 'upsell-static-subscription-activated',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/upsell-static-subscription-activated'),
	},

	{
		id: 'upsell-static-assessment-result',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/upsell-static-assessment-result'),
	},

	{
		id: 'upsell-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-f'),
	},
	{
		id: 'upsell-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-m'),
	},

	{
		id: 'upsell-activity-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-activity-f'),
	},
	{
		id: 'upsell-activity-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-activity-m'),
	},

	{
		id: 'upsell-yoga-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-yoga-f'),
	},
	{
		id: 'upsell-yoga-m-us',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-yoga-m-us'),
	},

	{
		id: 'upsell-tai-chi-walking-f',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-tai-chi-walking-f'),
	},

	{
		id: 'upsell-calisthenics-m',
		config: () => import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/upsell-calisthenics-m'),
	},

	// web_glp_upsell_fakedoor ⬇️
	{
		id: 'upsell-static-subscription-activated-no-bonus',
		config: () =>
			import(
				/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/glp/upsell-static-subscription-activated-no-bonus'
			),
	},
	{
		id: 'upsell-static-glp-intro',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/glp/upsell-static-glp-intro'),
	},
	{
		id: 'upsell-static-glp-loader',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/glp/upsell-static-glp-loader'),
	},
	{
		id: 'upsell-static-glp-treatment-loader',
		config: () =>
			import(
				/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/glp/upsell-static-glp-treatment-loader'
			),
	},
	{
		id: 'upsell-static-glp-offer',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/glp/upsell-static-glp-offer'),
	},
	{
		id: 'upsell-static-glp-checkout',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/glp/upsell-static-glp-checkout'),
	},
	{
		id: 'upsell-static-glp-preview',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/glp/upsell-static-glp-preview'),
	},
	{
		id: 'upsell-static-glp-result',
		config: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/static/glp/upsell-static-glp-result'),
	},
]

export const upsellOnboardingInstances = [
	{
		id: 'upsell-static-glp-onboarding',
		component: () =>
			import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/components/static/glp/UpsellStaticGlpOnboarding.vue'),
	},
]

const instancesRoutes = upsellInstances.map((instance) => ({
	path: `/upsell/${instance.id.replace('upsell-', '')}`,
	name: instance.id,
	component: {
		render: (h) =>
			h(UpsellView, {
				key: instance.id,
				props: {
					id: instance.id,
					config: instance.config,
				},
			}),
	},
	meta: {
		requiresUser: true,
	},
}))

const onboardingRoutes = upsellOnboardingInstances.map((instance) => ({
	path: `/upsell/${instance.id.replace('upsell-', '')}/:page*`,
	name: instance.id,
	component: instance.component,
	meta: {
		requiresUser: true,
	},
}))

export default [...instancesRoutes, ...onboardingRoutes]
